/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MapString,
  TenantWebhooks,
  TenantWebhooksWithMeta,
  ZapierAuthEchoResponse,
  ZapierCreateZapRequest,
  ZapierCreateZapResponse,
  ZapierDeleteZapRequest,
  ZapierIntegrationData,
  ZapierSampleRequest,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "zapier";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Create Zap
   *
   * @tags zap
   * @name CreateZap
   * @request POST:/v1/zap/new
   * @secure
   */
  createZap = (data: ZapierCreateZapRequest, params: RequestParams = {}) =>
    this.request<
      ZapierCreateZapResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/zap/new`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createZap */
  createZapPathGetter = () => this.getServicePath(`/v1/zap/new`);

  /**
   * @description Delete Zap
   *
   * @tags zap
   * @name DeleteZap
   * @request POST:/v1/zap/delete
   * @secure
   */
  deleteZap = (data: ZapierDeleteZapRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/zap/delete`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteZap */
  deleteZapPathGetter = () => this.getServicePath(`/v1/zap/delete`);

  /**
   * @description Sample For Zap
   *
   * @tags zap
   * @name SampleForZap
   * @request POST:/v1/zap/sample
   * @secure
   */
  sampleForZap = (data: ZapierSampleRequest, params: RequestParams = {}) =>
    this.request<
      any[],
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/zap/sample`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for sampleForZap */
  sampleForZapPathGetter = () => this.getServicePath(`/v1/zap/sample`);

  /**
   * @description Echo for zapier auth
   *
   * @tags auth
   * @name EchoForZapierAuth
   * @request GET:/v1/zap/auth-echo
   * @secure
   */
  echoForZapierAuth = (params: RequestParams = {}) =>
    this.request<
      ZapierAuthEchoResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/zap/auth-echo`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for echoForZapierAuth */
  echoForZapierAuthPathGetter = () => this.getServicePath(`/v1/zap/auth-echo`);

  /**
   * @description Get Zapier API key
   *
   * @tags admin
   * @name GetZapierApiKey
   * @request GET:/v1/tenant/{tenantId}/apikey/get
   * @secure
   */
  getZapierApiKey = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      ZapierIntegrationData,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/apikey/get`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getZapierApiKey */
  getZapierApiKeyPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/apikey/get`);

  /**
   * @description Get Zapier API key or create if one does not exist
   *
   * @tags admin
   * @name GetZapierApiKeyOrCreateIfOneDoesNotExist
   * @request GET:/v1/tenant/{tenantId}/apikey/get-or-create
   * @secure
   */
  getZapierApiKeyOrCreateIfOneDoesNotExist = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      ZapierIntegrationData,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/apikey/get-or-create`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getZapierApiKeyOrCreateIfOneDoesNotExist */
  getZapierApiKeyOrCreateIfOneDoesNotExistPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/apikey/get-or-create`);

  /**
   * @description Create a new Zapier API key, even if one already exists
   *
   * @tags admin
   * @name RecreateZapierApiKey
   * @request POST:/v1/tenant/{tenantId}/apikey/recreate
   * @secure
   */
  recreateZapierApiKey = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      ZapierIntegrationData,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/apikey/recreate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for recreateZapierApiKey */
  recreateZapierApiKeyPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/apikey/recreate`);

  /**
   * @description Delete Integration (removes API key from database thus disabling us sending events to Zapier)
   *
   * @tags zap
   * @name DeleteIntegration
   * @request POST:/v1/tenant/{tenantId}/apikey/delete
   * @secure
   */
  deleteIntegration = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/apikey/delete`,
      method: "POST",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteIntegration */
  deleteIntegrationPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/apikey/delete`);

  /**
   * @description Create Webhooks
   *
   * @tags webhook
   * @name CreateWebhooks
   * @request POST:/v1/tenant/{tenantId}/webhook/create
   * @secure
   */
  createWebhooks = (tenantId: string, data: TenantWebhooks, params: RequestParams = {}) =>
    this.request<
      TenantWebhooksWithMeta,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/webhook/create`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createWebhooks */
  createWebhooksPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/webhook/create`);

  /**
   * @description Get Webhooks
   *
   * @tags webhook
   * @name GetWebhooks
   * @request GET:/v1/tenant/{tenantId}/webhook/get
   * @secure
   */
  getWebhooks = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      TenantWebhooksWithMeta,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/webhook/get`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getWebhooks */
  getWebhooksPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/webhook/get`);

  /**
   * @description Update Webhooks
   *
   * @tags webhook
   * @name UpdateWebhooks
   * @request POST:/v1/tenant/{tenantId}/webhook/update
   * @secure
   */
  updateWebhooks = (tenantId: string, data: TenantWebhooks, params: RequestParams = {}) =>
    this.request<
      TenantWebhooksWithMeta,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/webhook/update`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateWebhooks */
  updateWebhooksPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/webhook/update`);

  /**
   * @description Delete Webhooks
   *
   * @tags webhook
   * @name DeleteWebhooks
   * @request POST:/v1/tenant/{tenantId}/webhook/delete
   * @secure
   */
  deleteWebhooks = (tenantId: string, data: object, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/webhook/delete`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteWebhooks */
  deleteWebhooksPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/webhook/delete`);
}
